var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gl-avatar',{attrs:{"shape":"rect","entity-name":_vm.projectName,"src":_vm.projectAvatarUrl,"alt":_vm.avatarAlt,"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }